export default "__VITE_ASSET__e7102548__"